import React, { useState, useCallback } from 'react'
import _ from 'lodash'
import { connect } from 'react-redux'
import api, { apiActionWithRoute } from '../../api'

import Input from '../input'
import IngredientsModal from '../ingredientsModal'

import { newStep } from '../../common/step'
import { getLetter, convertIngredientDescription } from '../../common/utils'

const inputStyle = { width: 'calc(100% - 50px)' }

const IngredientsSelector = ({
  currentIngredients,
  ingredients,
  onChange,
  text: originalText,
  path,
  section,
  defaultLocale,
  readOnly,
  inverted,
  ingredient,
  step,
  fetchIngredient,
  dispatch,
  disabled,
  ...props
}) => {

  const [modalOpened, setModalOpened] = useState(false)

  const handleOpen = useCallback(() => {
    if (!modalOpened) {
      setModalOpened(true)
    }
  }, [modalOpened])

  const handleClose = useCallback(() => {
    if (modalOpened) {
      setModalOpened(false)
    }
  }, [modalOpened])

  const handleConfirm = useCallback(ingredients => {
    (async () => {
      setModalOpened(false)
      const ingredient = ingredients[0]
      let replacementsInfo = []
      if (ingredient.recipeIngredient && ingredient.recipeIngredient.replacements) {
        replacementsInfo = await Promise.all(ingredient.recipeIngredient.replacements.map(v => fetchIngredient(v.ingredientID)))
      }

      onChange({
        target: {
          name: ingredient.newIngredientKey ? `${path}newIngredientKey` : `${path}recipeIngredientID`,
          value: ingredient.newIngredientKey || ingredient.recipeIngredientID,
        },
      }, (model, modifyUtils) => {
        _.set(model, `${path}newIngredientKey`, ingredient.newIngredientKey || undefined)
        _.set(model, `${path}recipeIngredientID`, ingredient.recipeIngredientID || undefined)
        _.set(model, `${path}video`, ingredient.image || undefined)
        _.set(model, `${path}description`, convertIngredientDescription(ingredient))

        modifyUtils.removeErrorsBlock(model, `${path}replacements`)
        if (ingredient.recipeIngredient && ingredient.recipeIngredient.replacements) {
          _.set(model, `${path}replacements`, ingredient.recipeIngredient.replacements.map((replacement, index) => {
            const orginalIngredient = replacementsInfo.find(i => i.id === replacement.ingredientID)
            if (!orginalIngredient) {
              if (!model.errors) {
                model.errors = {}
              }
              model.errors[`${path}replacements[${index}].description.${defaultLocale}`] = 'Field is required'
            }
            return newStep({
              defaultLocale,
              title: `${step.title[defaultLocale]} ${getLetter(index)}`,
              type: step.type,
              newIngredientKey: replacement.newIngredientKey,
              recipeIngredientID: replacement.recipeIngredientID,
              ingredientID: replacement.ingredientID,
              ...(orginalIngredient ? {
                video: orginalIngredient.image,
                description: convertIngredientDescription(orginalIngredient),
              } :  null),
            })
          }))
        } else {
          _.set(model, `${path}replacements`, undefined)
        }
        return model
      })
    })()

  }, [defaultLocale, fetchIngredient, onChange, path, step.title, step.type])
  const handleClick = useCallback(e => {
    if (!e.target.value) {
      handleOpen()
    }
  }, [handleOpen])

  const inputProps = originalText(props)

  const text = useCallback(({ name, ...props }) => {
    const originalProps = inputProps
    const ingredientName = ingredient ? (
      `${section ? `${section.title[defaultLocale]}: ` : ''}${(ingredients.find(i => i.id === parseInt(ingredient.ingredientID, 10)) || {}).name}` || ''
    ) : ''
    return {
      ...originalProps,
      value: ingredientName,
    }
  }, [defaultLocale, ingredient, ingredients, inputProps, section])

  const ingredientsList = currentIngredients()
  const selected = ingredient && ingredientsList.find(
    i => i.ingredientID === ingredient.id &&
    ((ingredient.newIngredientKey && ingredient.newIngredientKey === i.newIngredientKey)
     || (ingredient.recipeIngredientID && ingredient.recipeIngredientID === i.recipeIngredientID)),
  )

  return (
    <React.Fragment>
      <Input
        {...props}
        text={text}
        onClick={readOnly ? null : handleClick}
        onAdd={readOnly ? null : handleOpen}
        inputStyle={inputStyle}
        readOnly
        inverted={!!inverted}
        disabled={disabled}
      />
      {
        modalOpened && (
          <IngredientsModal
            onClose={handleClose}
            onChange={handleConfirm}
            filter={[]}
            fullWidth
            multi={false}
            selected={selected ? [selected] : []}
            title="Select ingredient"
            ingredients={ingredientsList}
            dontFetch
            groupItems
            disabled={disabled}
          />
        )
      }
    </React.Fragment>
  )
}

const mapDispatchToProps = dispatch => ({
  fetchIngredient: id => dispatch(apiActionWithRoute(api.getIngredient)(id)()),
})


export default connect(null, mapDispatchToProps)(IngredientsSelector)
